/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FixedDurationApiDto } from './fixed-duration.model';
import { CourseArticleApiDto } from './course-article.model';
import { CourseTypeApiDto } from './course-type.model';
import { LessonApiDto } from './lesson.model';
import { ProductPackageApiDto } from './product-package.model';
import { PriceItemApiDto } from './price-item.model';
import { ScheduleApiDto } from './schedule.model';
import { CourseLevelApiDto } from './course-level.model';
import { ChildCourseTypeApiDto } from './child-course-type.model';
import { AmountApiDto } from './amount.model';
import { CodeAndNameApiDto } from './code-and-name.model';
import { CourseDatesApiDto } from './course-dates.model';

export interface CourseApiDto {
  fixedDurations?: Array<FixedDurationApiDto>;
  ageDescription?: string;
  isWeeklyCourse?: boolean;
  showDatesAsList?: boolean;
  sessionDates?: Array<CourseDatesApiDto>;
  school?: CodeAndNameApiDto;
  disciplines?: Array<CodeAndNameApiDto>;
  studyModes?: Array<CodeAndNameApiDto>;
  academicLevels?: Array<CodeAndNameApiDto>;
  learningModes?: Array<CodeAndNameApiDto>;
  specialisations?: Array<CodeAndNameApiDto>;
  schoolIcon?: string;
  availableInternational?: boolean;
  courseDuration?: string;
  courseLanguage?: string;
  productPackage?: ProductPackageApiDto;
  courseClassification?: CourseApiDto.CourseClassificationEnum;
  /**
   * List of course benefits (e.g., for online courses)
   */
  benefits?: Array<string>;
  code?: string;
  name?: string;
  description?: string;
  shortName?: string;
  thumbnailSmall?: string;
  type?: CourseTypeApiDto;
  childType?: ChildCourseTypeApiDto;
  lesson?: LessonApiDto;
  supportedLevels?: Array<CourseLevelApiDto>;
  accommodationMandatory?: boolean;
  /**
   * Current available year
   */
  schoolYear?: number;
  /**
   * All available years
   */
  schoolYears?: Array<number>;
  providerName?: string;
  durationMin?: number;
  durationMax?: number;
  durationUnit?: CourseApiDto.DurationUnitEnum;
  studentAgeMin?: number;
  studentQtyMax?: number;
  courseDates?: Array<CourseDatesApiDto>;
  examDates?: Array<CourseDatesApiDto>;
  schedules?: Array<ScheduleApiDto>;
  samplePrice?: AmountApiDto;
  internationalPrice?: AmountApiDto;
  priceTable?: Array<PriceItemApiDto>;
  courseArticles?: Array<CourseArticleApiDto>;
  quotable?: boolean;
  pageUrl?: string;
  /**
   * Custom element weigh. This property is used to define a custom sort order of this element.
   */
  weight?: number;
  productPosition?: number;
  /**
   * Codes of connected products
   */
  relatedProducts?: Array<string>;
}
export namespace CourseApiDto {
  export const CourseClassificationEnum = {
    standard: 'standard',
    intensive: 'intensive',
    private_lessons: 'private lessons',
    another_type_of_course_other_than_previous_ones: 'another type of course other than previous ones',
  } as const;
  export type CourseClassificationEnum = (typeof CourseClassificationEnum)[keyof typeof CourseClassificationEnum];
  export const DurationUnitEnum = {
    WEEKS: 'WEEKS',
    MONTH: 'MONTH',
    DAYS: 'DAYS',
    YEARS: 'YEARS',
    EACH: 'EACH',
    HOURS: 'HOURS',
    LESSONS: 'LESSONS',
  } as const;
  export type DurationUnitEnum = (typeof DurationUnitEnum)[keyof typeof DurationUnitEnum];
}
